<template>
    <div id="top" class="wrapper">
        <hero></hero>
        <navigation></navigation>

        <main class="main">
            <div class="section_alt">
                <credits></credits>
                <instagram></instagram>
            </div>
            <section class="section_alt2">
                <h1 id="about" class="section--bar_title">About the movie</h1>
                <introduction></introduction>
                <story></story>
            </section>
            <div class="section">
                <casts></casts>
                <director></director>
                <novel></novel>
                <music></music>
                <!--<reviews></reviews>-->
                <site-banner></site-banner>
                <!--<theater></theater>-->
            </div>
        </main>

        <footer-tag></footer-tag>
    </div>
</template>

<script>
import Vue from 'vue'
import Hero from '@/components/Hero'
import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import Credits from '@/components/Credits'
import Introduction from '@/components/Introduction'
import Story from '@/components/Story'
import Casts from '@/components/Casts'
import Director from '@/components/Director'
import Novel from '@/components/Novel'
import Music from '@/components/Music'
import Reviews from '@/components/Reviews'
import Sitebanner from '@/components/Sitebanner'
import Theaters from '@/components/Theaters'
import Instagram from '@/components/Instagram'

Vue.component('hero', Hero)
Vue.component('navigation', Navigation)
Vue.component('footer-tag', Footer)
Vue.component('credits', Credits)
Vue.component('introduction', Introduction)
Vue.component('story', Story)
Vue.component('casts', Casts)
Vue.component('director', Director)
Vue.component('novel', Novel)
Vue.component('music', Music)
Vue.component('reviews', Reviews)
Vue.component('site-banner', Sitebanner)
Vue.component('theater', Theaters)
Vue.component('instagram', Instagram)

export default {
    name: 'Home',
    metaInfo: {
        title: 'Home'
    },
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue